import { Grid, Pagination, Typography, useTheme } from '@mui/material';
import { styled } from '@mui/system';
import React from 'react';

import { PaginationData } from '../../../types/type';

export const ShopAddressTypography = styled(Typography)(() => ({
  color: '#393939',
  fontWeight: 400,
  fontSize: '14px',
  fontFamily: `${useTheme().custom.styles.primaryDescription}`,
}));

interface Props {
  paginationData: PaginationData | null | undefined;
  pageSelectionChangeHandler: (pageNumber: number) => void | undefined;
}

const Pages = (props: Props) => {
  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    props.pageSelectionChangeHandler(value);
  };

  return (
    <Grid container direction="column" justifyContent="space-between" alignItems="center" spacing={2}>
      <Grid item>
        <Pagination count={props.paginationData?.pageCount} onChange={handleChange} />{' '}
      </Grid>
      <Grid item>
        <ShopAddressTypography variant="body2">
          {`Showing ${props.paginationData?.starting} - ${props.paginationData?.ending} of ${props.paginationData?.totalResultCount} results`}
        </ShopAddressTypography>
      </Grid>
    </Grid>
  );
};

export default Pages;
